var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNounPointer = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "-5 -10 110 135",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M82.488 57.461c.18-.61-.04-1.27-.55-1.64L19.838 10.288a1.52 1.52 0 0 0-1.558-.129c-.5.262-.82.77-.82 1.34v77c0 .64.398 1.2 1 1.422.16.059.327.078.5.078.449 0 .878-.199 1.171-.558l23.5-29.262 37.5-1.66a1.52 1.52 0 0 0 1.371-1.06zm-39.68-.25c-.43.02-.828.219-1.102.559L20.444 84.239l.004-69.777 56.281 41.25-33.91 1.5z"
})));
export { SvgNounPointer as ReactComponent };
export default __webpack_public_path__ + "assets/images/noun-pointer.svg";